var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('NavBar',{attrs:{"app":"","show-only-logo":true}}),_vm._v(" "),_c('v-main',[_c('v-container',[_c('nuxt')],1)],1),_vm._v(" "),_c('Footer',{attrs:{"app":"","show-trial":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }